module.exports = __webpack_public_path__ + "img/user-add.4c5030ed.svg";